import { Popup } from 'semantic-ui-react';
import { Label } from '@britishcouncil/react-admin';
import { TrainingCategory } from 'api';

export const TrainingCategoryLabel = ({ value }: { value: TrainingCategory }) => {
  return (
    <Popup
      content={TrainingCategory[value]}
      trigger={<Label>{TrainingCategory[value].charAt(0)}</Label>}
    />
  );
};
